// extracted by mini-css-extract-plugin
export default {"uploadButton":"Jwaci","disabled":"sSYCd","normal":"QCnNO","big":"VrPYk","fileInputLabel":"JyJlc","fileInput":"VwAkb","icon":"lBT3e"};